'use client';

import * as React from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

const LAST_ROUTE_KEY = 'womo:lastRoute';

export default function RouteTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  React.useEffect(() => {
    if (typeof window === 'undefined') return;

    const qs = searchParams?.toString();
    const fullPath = `${pathname}${qs ? `?${qs}` : ''}`;

    // 這些是「modal 本身的 URL」：不要覆蓋 opener
    const isModalLike = pathname.startsWith('/ar-space/') || pathname.startsWith('/article/');

    if (isModalLike) return;

    try {
      sessionStorage.setItem(LAST_ROUTE_KEY, fullPath);
    } catch {
      // ignore
    }
  }, [pathname, searchParams]);

  return null;
}
